<template>
	<div :id="id" class="card" :class="`bg-${theme}`" style="min-height: 530px;">
		<div class="card-header border-0">
			<div class="row" style="justify-content: space-between">
				<h3 class=" card-title" :title="title"
					style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;max-width: 65%">
					<i :class="icon" class="mr-1"></i>
					{{ title }}
				</h3>
				<!-- card tools -->
				<div class="">
					<div class="card-tools float-right">
						<slot name="card-tools" v-bind:theme="theme"></slot>
					</div>
				</div>
				<!-- /.card-tools -->
			</div>
		</div>
		<div class="card-header border-0 p-0" style="border-radius: 0">
			<slot name="search">
				<div class="nav navbar navbar-expand p-2">
					<a class="btn btn-sidebar ml-1 float-right" :class="`bg-${theme}`" href="#"><i
							class="fas fa-search"></i></a>
				</div>
			</slot>
		</div>
		<div class="card-body">
			<ve-line ref="vchart" height="400px" :data="data" :judge-width="true" :settings="settings" :x-axis="xAxis"
				:y-axis="yAxis" :legend="legend"></ve-line>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'lyai-line',
		props: {
			theme: {
				type: String,
				default () {
					return 'gradient-primary'
				}
			},
			icon: {
				type: String,
				default () {
					return 'fas fa-clock'
				}
			},
			id: {
				type: String,
				default () {
					return 'id'
				}
			},
			data: {
				type: Object
			},
			title: {
				type: String,
				default () {
					return '折线图'
				}
			},
			checked: {
				type: Boolean,
				default () {
					return false
				}
			},
			time: {
				type: Number,
				default () {
					return 5
				}
			},
			auto: {
				type: Boolean,
				default () {
					return false
				}
			},
			settings: {
				type: Object
			},
			w: {
				type: Number,
				default () {
					return 0
				}
			},
			h: {
				type: Number,
				default () {
					return 0
				}
			},
			textStyle: {
				type: Object,
				default () {
					return {
						color: "white", //这里是改变字体颜色
						fontSize: 18 //字体大小
					}
				}
			},
			lineStyle: {
				type: Object,
				default () {
					return {
						color: "white", //这里是改变字体颜色
						width: 1, //线的大小
						type: "solid" //Y轴线的类型
					}
				}
			}
		},
		data() {
			return {
				body: undefined,
				loading: undefined,
				interval: undefined,
			}
		},
		created() {
			this.updateData()
		},
		computed: {
			xAxis() {
				return {
					data: this.data.rows.map(t => t['x']),
					axisLabel: {
						interval: 0,
						rotate: 12 * (parseInt(this.data.rows.length / 10)),
						textStyle: {...this.textStyle, fontSize: 12}
					},
					axisLine: {
						lineStyle: this.lineStyle
					},
				}
			},
			yAxis() {
				return {
					axisLabel: {
						show: true,
						textStyle: this.textStyle
					},
					axisLine: {
						lineStyle: this.lineStyle
					},
				}
			},
			legend() {
				return {
					textStyle: {...this.textStyle, fontSize: 12}
				}
			}
		},
		watch: {
			checked(val) {
				if (val) {
					this.updateData()
				}
			},
			auto(val) {
				if (val) {
					this.interval = setInterval(() => {
						this.updateData(true)
					}, this.time * 1000)
				} else {
					clearInterval(this.interval)
				}
			},
			time(val) {
				if (this.auto) {
					clearInterval(this.interval)
					this.interval = setInterval(() => {
						this.updateData(true)
					}, val * 1000)
				}
			}
		},
		methods: {
			updateData() {
				if (this.auto) {
					this.$emit('updateData', () => {
						this.$nextTick(() => {
							this.loading = this.$loading({
								target: document.getElementById(this.id),
								text: 'Loading',
								spinner: 'el-icon-loading',
								background: 'rgba(0, 0, 0, 0.7)'
							})
						})
					}, () => {
						this.$nextTick(() => {
							setTimeout(() => {
								this.loading && this.loading.close()
							}, 500)
						})
					})
					return
				}
				this.$emit('updateData', () => {
					this.$nextTick(() => {
						this.loading = this.$loading({
							target: document.getElementById(this.id),
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						})
					})
				}, () => {
					this.$nextTick(() => {
						setTimeout(() => {
							this.loading && this.loading.close()
						}, 500)
					})
				})
			}
		}
	}
</script>
